module.exports = __webpack_public_path__ + "static/media/crystal_ball.e509b246.webp";